import { render } from "./LoginView.vue?vue&type=template&id=651d78c3&scoped=true&ts=true"
import script from "./LoginView.vue?vue&type=script&lang=ts"
export * from "./LoginView.vue?vue&type=script&lang=ts"

import "./LoginView.vue?vue&type=style&index=0&id=651d78c3&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651d78c3"]])

export default __exports__